import { render, staticRenderFns } from "./NsRadio.vue?vue&type=template&id=5ca3ea40&scoped=true&"
import script from "./NsRadio.vue?vue&type=script&lang=js&"
export * from "./NsRadio.vue?vue&type=script&lang=js&"
import style0 from "./NsRadio.vue?vue&type=style&index=0&id=5ca3ea40&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ca3ea40",
  null
  
)

export default component.exports